import { render, staticRenderFns } from "./AdminShipping.vue?vue&type=template&id=e2ba0d80&"
import script from "./AdminShipping.vue?vue&type=script&lang=js&"
export * from "./AdminShipping.vue?vue&type=script&lang=js&"
import style0 from "./AdminShipping.vue?vue&type=style&index=0&id=e2ba0d80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports